import React, { useEffect, useState, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import { calculateAverage, calculateMinimum, calculateMaximum } from "../../utilities";
import { TestsContext } from "../../contexts";
import { Stat } from "../common";

const initJitter = (tests) => {
  let j = [];
  for (var n = 0; n < tests.length - 1; ++n) {
    j.push(Math.trunc(Math.abs(tests[n] - tests[n + 1])));
  }
  return j;
};

export const JitterDetail = (props) => {
  //  const [data, setData] = useState([]);

  const [avg, setAverage] = useState(0);
  const [min, setMinimum] = useState(0);
  const [max, setMaximum] = useState(0);
  const { tests } = useContext(TestsContext);
  const { index } = props;

  /** Check if there is any data to display.
   */

  useEffect(() => {
    const hasData = (index) => {
      return tests !== null && Array.isArray(tests.times) && Array.isArray(tests.times[index]);
    };

    //let d = !props.data || !props.data//.length ? [] : props.data;

    if (!hasData(index)) return;

    let jitter = initJitter(tests?.times[index] ?? []);

    setAverage(() => Math.trunc(calculateAverage(jitter)));
    setMinimum(() => Math.trunc(calculateMinimum(jitter)));
    setMaximum(() => Math.trunc(calculateMaximum(jitter)));
  }, [tests, index]);

  return (
    <div className='p-2'>
      <Row className='g-0 m-0 p-0'>
        <Col className='col-4  text-center'>
          <Stat title='Average' value={avg} size='sm' />
        </Col>
        <Col className='col-4  text-center'>
          <Stat title='Minimum' value={min} size='sm' />
        </Col>
        <Col className='col-4  text-center'>
          <Stat title='Maximum' value={max} size='sm' />
        </Col>
      </Row>
    </div>
  );
};
